module.exports = __webpack_public_path__ + "static/simplymoneylyfe-a8fe9c4a80121f6c34d77b27251dad46.png";